
export const stringVariableExpand = function(str: string, json: any) {
    let regexp = /\${([^{]+)}/g;
    return str.replace(regexp, function(ignore, key: any){
        return (key = json[key]) == null ? '' : key;
    });
}
